import QuoteLinkFooter from './QuoteLinkFooter';

export default function QuoteLinkLayout(props) {
  const { children, footerInfo, brandLogo } = props;

  const {
    phoneNumber,
    emailAddress,
    privacyPolicyUrl,
    termsAndConditionsUrl,
    travelQAndAUrl,
    copyrightMessage,
  } = footerInfo;
  return (
    <>
      {children}
      <QuoteLinkFooter
        brandLogo={brandLogo}
        phoneNumber={phoneNumber}
        emailAddress={emailAddress}
        privacyPolicyUrl={privacyPolicyUrl}
        termsAndConditionsUrl={termsAndConditionsUrl}
        travelQAndAUrl={travelQAndAUrl}
        copyrightMessage={copyrightMessage}
      />
    </>
  );
}
